/** Mock SSOT for HotelsRiver packages-results UI demo — no API. */

/** Applied search that produced the current results (must match result destination). */
export const INITIAL_APPLIED_SEARCH = {
  destinationId: "budapest",
  destinationLabel: "בודפשט",
  dateRangeLabel: "15–19 בנובמבר",
  dateRangeInput: "15/11/2026 - 19/11/2026",
  adults: 2,
  children: 0,
  infants: 0,
  rooms: 1,
  occupancyLabel: "2 מבוגרים · חדר אחד",
  checkIn: "2026-11-15",
  checkOut: "2026-11-19",
};

/** @deprecated use INITIAL_APPLIED_SEARCH */
export const MOCK_SEARCH = INITIAL_APPLIED_SEARCH;

export function formatSearchSummary(search) {
  if (!search) return "";
  const dest = search.destinationLabel || "יעד";
  const dates = search.dateRangeLabel || search.dateRangeInput || "";
  const pax = search.occupancyLabel || "";
  return [dest, dates, pax].filter(Boolean).join(" · ");
}

export function cloneSearch(search) {
  return { ...search };
}

export function validateSearchDraft(draft) {
  if (!draft?.destinationId) {
    return "נא לבחור יעד לחיפוש";
  }
  if (!draft?.dateRangeInput && !draft?.dateRangeLabel) {
    return "נא לבחור תאריכים";
  }
  if (!Number(draft?.adults) || Number(draft.adults) < 1) {
    return "נא להגדיר לפחות מבוגר אחד";
  }
  if (!Number(draft?.rooms) || Number(draft.rooms) < 1) {
    return "נא להגדיר לפחות חדר אחד";
  }
  return null;
}

export const MOCK_FILTER_DESTINATIONS = [
  { id: "budapest", label: "בודפשט", count: 48 },
  { id: "dubai", label: "דובאי", count: 112 },
  { id: "prague", label: "פראג", count: 67 },
  { id: "athens", label: "אתונה", count: 54 },
  { id: "barcelona", label: "ברצלונה", count: 89 },
  { id: "rome", label: "רומא", count: 73 },
];

/** Board / lodging type — same options in top bar + sidebar */
export const MOCK_BOARD_OPTIONS = [
  { id: "ro", label: "לינה בלבד" },
  { id: "bb", label: "לינה וארוחת בוקר", shortLabel: "ארוחת בוקר" },
  { id: "hb", label: "חצי פנסיון" },
  { id: "fb", label: "פנסיון מלא" },
];

export const MOCK_BOARD_TOP_FILTERS = [
  { id: "all", label: "סוג אירוח" },
  ...MOCK_BOARD_OPTIONS,
];

export const MOCK_STAR_OPTIONS = [
  { id: 5, label: "5 כוכבים" },
  { id: 4, label: "4 כוכבים" },
  { id: 3, label: "3 כוכבים" },
  { id: 2, label: "2 כוכבים ומטה" },
];

export const MOCK_NIGHTS_OPTIONS = [
  { id: 3, label: "3 לילות" },
  { id: 4, label: "4 לילות" },
  { id: 5, label: "5 לילות" },
  { id: 7, label: "7 לילות" },
];

/** Agent quick filters — streamline sales workflow */
export const MOCK_AGENT_QUICK_FILTERS = [
  { id: "immediate", label: "אישור מיידי" },
  { id: "baggage", label: "כבודה כלולה" },
  { id: "direct", label: "טיסה ישירה" },
  { id: "transfer", label: "כולל העברה" },
];

export const MOCK_DEPARTURE_WINDOWS = [
  { id: "all", label: "שעת המראה" },
  { id: "morning", label: "בוקר (עד 12:00)" },
  { id: "afternoon", label: "צהריים (12–17)" },
  { id: "evening", label: "ערב (מ־17:00)" },
];

/** Top-bar seats filter — agent sees remaining flight seats */
export const MOCK_SEATS_FILTERS = [
  { id: "all", label: "מקומות", minSeats: 0 },
  { id: "any", label: "יש מקומות", minSeats: 1 },
  { id: "gte4", label: "4+ מקומות", minSeats: 4 },
  { id: "gte6", label: "6+ מקומות", minSeats: 6 },
  { id: "gte9", label: "9+ מקומות", minSeats: 9 },
];

export const MOCK_BAGGAGE_FILTERS = [
  { id: "trolley", label: "טרולי כלול" },
  { id: "checked", label: "מזוודה כלולה" },
  { id: "none", label: "ללא כבודה" },
];

/** Bottleneck seats across package flight legs (agent inventory signal). */
export function getPackageSeatsLeft(pkg) {
  const seats = [pkg?.outbound?.seatsLeft, pkg?.inbound?.seatsLeft]
    .map((n) => Number(n))
    .filter((n) => Number.isFinite(n) && n >= 0);
  if (!seats.length) return null;
  return Math.min(...seats);
}

export const MOCK_PACKAGES = [
  {
    id: "pkg-7seasons",
    hotelName: "7SEASONS APARTMENTS",
    stars: 4,
    city: "בודפשט",
    country: "הונגריה",
    destinationId: "budapest",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "סטודיו",
    nights: 4,
    dateRangeLabel: "15 - 19 נובמבר 2026",
    pricePerPerson: 2490,
    totalForTwo: 4980,
    currency: "EUR",
    agentNetPerPerson: 638,
    agentNetPerPersonIls: 2210,
    commissionPercent: 11,
    immediateConfirm: true,
    directFlight: true,
    transferIncluded: false,
    highCommission: false,
    flightOptionsCount: 4,
    baggage: {
      level: "trolley",
      bullets: ['טרולי 8 ק"ג כלול'],
      none: false,
    },
    imageUrl:
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80&auto=format&fit=crop",
    outbound: {
      from: "TLV",
      to: "BUD",
      depart: "06:40",
      arrive: "09:55",
      airline: "Wizz Air",
      airlineCode: "W6",
      flightNo: "W6 246",
      duration: "3ש 15ד",
      seatsLeft: 3,
    },
    inbound: {
      from: "BUD",
      to: "TLV",
      depart: "22:10",
      arrive: "01:55+1",
      airline: "Wizz Air",
      airlineCode: "W6",
      flightNo: "W6 247",
      duration: "3ש 45ד",
      seatsLeft: 5,
    },
  },
  {
    id: "pkg-danubius",
    hotelName: "DANUBIUS HOTEL HELIA",
    stars: 4,
    city: "בודפשט",
    country: "הונגריה",
    destinationId: "budapest",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "חדר סטנדרט",
    nights: 4,
    dateRangeLabel: "15 - 19 נובמבר 2026",
    pricePerPerson: 2780,
    totalForTwo: 5560,
    currency: "EUR",
    agentNetPerPerson: 678,
    agentNetPerPersonIls: 2350,
    commissionPercent: 15,
    immediateConfirm: true,
    directFlight: true,
    transferIncluded: true,
    highCommission: true,
    flightOptionsCount: 6,
    baggage: {
      level: "checked",
      bullets: ['טרולי 8 ק"ג כלול', 'מזוודה 23 ק"ג כלולה'],
      none: false,
    },
    imageUrl:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80&auto=format&fit=crop",
    outbound: {
      from: "TLV",
      to: "BUD",
      depart: "10:15",
      arrive: "13:30",
      airline: "El Al",
      flightNo: "LY 2365",
      duration: "3ש 15ד",
      seatsLeft: 9,
    },
    inbound: {
      from: "BUD",
      to: "TLV",
      depart: "14:45",
      arrive: "18:20",
      airline: "El Al",
      flightNo: "LY 2366",
      duration: "3ש 35ד",
      seatsLeft: 8,
    },
  },
  {
    id: "pkg-aria",
    hotelName: "ARIA HOTEL BUDAPEST",
    stars: 5,
    city: "בודפשט",
    country: "הונגריה",
    destinationId: "budapest",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "Deluxe",
    nights: 4,
    dateRangeLabel: "15 - 19 נובמבר 2026",
    pricePerPerson: 3890,
    totalForTwo: 7780,
    currency: "EUR",
    agentNetPerPerson: 1016,
    agentNetPerPersonIls: 3520,
    commissionPercent: 9,
    immediateConfirm: false,
    directFlight: true,
    transferIncluded: false,
    highCommission: false,
    flightOptionsCount: 2,
    baggage: {
      level: "none",
      bullets: [],
      none: true,
    },
    imageUrl:
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80&auto=format&fit=crop",
    outbound: {
      from: "TLV",
      to: "BUD",
      depart: "06:40",
      arrive: "09:55",
      airline: "Wizz Air",
      flightNo: "W6 246",
      duration: "3ש 15ד",
      seatsLeft: 2,
    },
    inbound: {
      from: "BUD",
      to: "TLV",
      depart: "22:10",
      arrive: "01:55+1",
      airline: "Wizz Air",
      flightNo: "W6 247",
      duration: "3ש 45ד",
      seatsLeft: 2,
    },
  },
  {
    id: "pkg-atlantis",
    hotelName: "ATLANTIS THE PALM",
    stars: 5,
    city: "דובאי",
    country: "איחוד האמירויות",
    destinationId: "dubai",
    boardId: "hb",
    boardLabel: "חצי פנסיון",
    roomType: "Ocean View",
    nights: 5,
    dateRangeLabel: "20 - 25 נובמבר 2026",
    pricePerPerson: 5200,
    totalForTwo: 10400,
    currency: "USD",
    agentNetPerPerson: 1431,
    agentNetPerPersonIls: 4420,
    commissionPercent: 15,
    immediateConfirm: true,
    directFlight: true,
    transferIncluded: true,
    highCommission: true,
    flightOptionsCount: 5,
    baggage: {
      level: "checked",
      bullets: ['טרולי 8 ק"ג כלול', 'מזוודה 23 ק"ג כלולה'],
      none: false,
    },
    imageUrl:
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80&auto=format&fit=crop",
    outbound: {
      from: "TLV",
      to: "DXB",
      depart: "00:50",
      arrive: "06:05",
      airline: "El Al",
      flightNo: "LY 971",
      duration: "4ש 15ד",
      seatsLeft: 7,
    },
    inbound: {
      from: "DXB",
      to: "TLV",
      depart: "08:30",
      arrive: "11:15",
      airline: "El Al",
      flightNo: "LY 972",
      duration: "3ש 45ד",
      seatsLeft: 6,
    },
  },
  {
    id: "pkg-nh-prague",
    hotelName: "NH PRAGUE CITY",
    stars: 4,
    city: "פראג",
    country: "צ'כיה",
    destinationId: "prague",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "Superior",
    nights: 3,
    dateRangeLabel: "12 - 15 דצמבר 2026",
    pricePerPerson: 2150,
    totalForTwo: 4300,
    currency: "EUR",
    agentNetPerPerson: 545,
    agentNetPerPersonIls: 1890,
    commissionPercent: 12,
    immediateConfirm: true,
    directFlight: false,
    transferIncluded: false,
    highCommission: false,
    flightOptionsCount: 3,
    baggage: {
      level: "trolley",
      bullets: ['טרולי 8 ק"ג כלול'],
      none: false,
    },
    imageUrl:
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80&auto=format&fit=crop",
    outbound: {
      from: "TLV",
      to: "PRG",
      depart: "07:20",
      arrive: "12:45",
      airline: "Smartwings",
      flightNo: "QS 1285",
      duration: "6ש 25ד",
      stopsLabel: "עצירה 1",
      seatsLeft: 4,
    },
    inbound: {
      from: "PRG",
      to: "TLV",
      depart: "11:30",
      arrive: "18:10",
      airline: "Smartwings",
      flightNo: "QS 1286",
      duration: "5ש 40ד",
      stopsLabel: "עצירה 1",
      seatsLeft: 5,
    },
  },
  {
    id: "pkg-electra",
    hotelName: "ELECTRA PALACE ATHENS",
    stars: 5,
    city: "אתונה",
    country: "יוון",
    destinationId: "athens",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "Classic",
    nights: 4,
    dateRangeLabel: "01 - 05 דצמבר 2026",
    pricePerPerson: 3120,
    totalForTwo: 6240,
    currency: "EUR",
    agentNetPerPerson: 773,
    agentNetPerPersonIls: 2680,
    commissionPercent: 14,
    immediateConfirm: true,
    directFlight: true,
    transferIncluded: true,
    highCommission: true,
    flightOptionsCount: 7,
    baggage: {
      level: "checked",
      bullets: ['טרולי 8 ק"ג כלול', 'מזוודה 23 ק"ג כלולה'],
      none: false,
    },
    imageUrl:
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80&auto=format&fit=crop",
    outbound: {
      from: "TLV",
      to: "ATH",
      depart: "08:05",
      arrive: "10:40",
      airline: "Aegean",
      flightNo: "A3 929",
      duration: "2ש 35ד",
      seatsLeft: 11,
    },
    inbound: {
      from: "ATH",
      to: "TLV",
      depart: "19:15",
      arrive: "20:55",
      airline: "Aegean",
      flightNo: "A3 928",
      duration: "1ש 40ד",
      seatsLeft: 10,
    },
  },
];

export const MOCK_TOTAL_FOUND = 493;

export function formatIls(amount) {
  return `₪${Number(amount).toLocaleString("he-IL")}`;
}

/** Format API original currency (USD / EUR). */
export function formatFx(amount, currency = "USD") {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const formatted = Math.round(n).toLocaleString("en-US");
  return currency === "EUR" ? `€${formatted}` : `$${formatted}`;
}

export function getPackageCurrency(pkg) {
  return pkg?.currency === "EUR" ? "EUR" : "USD";
}

/** Net per person in the package's original API currency. */
export function getAgentNetOriginal(pkg) {
  return Number(pkg?.agentNetPerPerson) || 0;
}

export function getAgentNetTotalOriginal(pkg, paxCount = 2) {
  return getAgentNetOriginal(pkg) * (Number(paxCount) || 2);
}

/** ILS companion display amount from API / conversion. */
export function getAgentNetIls(pkg) {
  return Number(pkg?.agentNetPerPersonIls ?? pkg?.pricePerPerson) || 0;
}

export function getAgentNetTotalIls(pkg, paxCount = 2) {
  return getAgentNetIls(pkg) * (Number(paxCount) || 2);
}

export function getDepartureWindow(departTime) {
  const hour = Number(String(departTime || "").split(":")[0]);
  if (!Number.isFinite(hour)) return null;
  if (hour < 12) return "morning";
  if (hour < 17) return "afternoon";
  return "evening";
}
